(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/components/game-card/buyin-info.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/components/game-card/buyin-info.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useContext = _React.useContext,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const getWeekdayAndTime = svs.utils.date.getWeekdayAndTime;
const clientNow = svs.numbergames.draws.drawsApi.clientNow;
const Countdown = svs.numbergames.fractiongames.components.gamecard.Countdown;
const ContainerContext = svs.numbergames.fractiongames.contexts.ContainerContext;
const MS_IN_MINUTE = 60 * 1000;
const initShowCountdown = buyinCloseTime => {
  if (!buyinCloseTime) return false;
  const millisecondsDiff = dateFns.differenceInMilliseconds(new Date(buyinCloseTime), clientNow());
  const minutesLeft = Math.ceil(millisecondsDiff / MS_IN_MINUTE);
  return minutesLeft > 0 && minutesLeft < 60;
};
const BuyInInfo = () => {
  const _useContext = useContext(ContainerContext),
    selectors = _useContext.selectors;
  const isOpen = useSelector(selectors.selectIsOpen);
  const buyinCloseTime = useSelector(selectors.selectBuyinCloseTime);
  const _useState = useState(initShowCountdown(buyinCloseTime)),
    _useState2 = _slicedToArray(_useState, 2),
    showCountdown = _useState2[0],
    setShowCountdown = _useState2[1];
  useEffect(() => {
    if (!isOpen) {
      setShowCountdown(false);
    } else if (!showCountdown) {
      const buyinCloseDate = new Date(buyinCloseTime);
      if (!dateFns.differenceInDays(buyinCloseDate, clientNow())) {
        const timeout = setTimeout(() => {
          setShowCountdown(true);
        }, dateFns.differenceInMilliseconds(buyinCloseDate, clientNow()) - 59 * MS_IN_MINUTE);
        return () => clearTimeout(timeout);
      }
    }
  }, [buyinCloseTime, isOpen, showCountdown]);
  if (isOpen && showCountdown) {
    return React.createElement(Countdown, null);
  }
  if (isOpen) {
    return "K\xF6pstopp: ".concat(getWeekdayAndTime(buyinCloseTime));
  }
  return 'Köpstopp';
};
svs.numbergames.fractiongames.components.gamecard.BuyInInfo = BuyInInfo;

 })(window);